import { Button } from "primereact/button";
import { Defect } from "../../types/defect";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { setToEdit } from "../../store/slices/defectSlice";
import { useCallback } from "react";
import { selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";

export const DefectTableActionsBody = (defect: Defect) => {
    const dispatch = useAppDispatch();

    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onEdit = useCallback(() => {
        dispatch(setToEdit(defect));
    }, [defect]);

    return (
        <div className="flex">
            <Button
                icon="pi pi-pencil"
                rounded
                text
                onClick={onEdit}
                disabled={inspectionDisabled}
                tooltip="Edit"
                tooltipOptions={{ position: "top" }}
            />
        </div>
    );
};
